import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

const Wrapper = styled.div`
  &:focus-within {
    outline: none;
  }

  input {
    height: 4.2rem;
  }

  input,
  textarea {
    width: 100%;
    padding: 1.2rem 1.6rem;
    border-radius: 4px;
    background: #f7f9fb;
    font-size: 1.4rem;

    &:focus-within,
    &:focus-visible,
    &:focus {
      box-shadow: 0 0 1px 1px #3e7eee !important;
    }

    &::placeholder {
      color: var(--grey-600);
    }
  }

  &.with-border input {
    border: 1px solid #f2f2f2;
  }

  &.has-icon {
    position: relative;

    input {
      width: 100%;
      margin-top: 0;
    }

    &:after,
    .icon {
      position: absolute;
      width: 1.6rem;
      height: 1.6rem;
      top: 48%;
      transform: translateY(-50%);
      right: 1.6rem;
      z-index: 1;
      cursor: pointer;
      //pointer-events: none;
    }
  }

  &.firefox {
    input {
      padding-right: 3.6rem;
    }
  }

  &.time-icon {
    &:after {
      content: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.3' fill-rule='evenodd' clip-rule='evenodd' d='M9 15.75C5.68629 15.75 3 13.0637 3 9.75C3 6.43629 5.68629 3.75 9 3.75C12.3137 3.75 15 6.43629 15 9.75C15 13.0637 12.3137 15.75 9 15.75Z' fill='%23807F7F'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.75 3.79642V3H10.5C10.9142 3 11.25 2.66421 11.25 2.25C11.25 1.83579 10.9142 1.5 10.5 1.5H7.5C7.08579 1.5 6.75 1.83579 6.75 2.25C6.75 2.66421 7.08579 3 7.5 3H8.25V3.79642C8.4957 3.76578 8.746 3.75 9 3.75C9.254 3.75 9.5043 3.76578 9.75 3.79642Z' fill='%23807F7F'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.6242 5.92783L14.2111 5.34088C14.504 5.04798 14.504 4.57311 14.2111 4.28022C13.9182 3.98732 13.4434 3.98732 13.1505 4.28022L12.5312 4.89943C12.9371 5.19551 13.3044 5.5413 13.6242 5.92783Z' fill='%23807F7F'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.59753 5.9989C8.61376 5.78792 8.78969 5.625 9.0013 5.625C9.2129 5.625 9.38883 5.78792 9.40506 5.9989L9.70988 9.96165C9.73222 10.252 9.50261 10.5 9.21136 10.5H8.79123C8.49998 10.5 8.27037 10.252 8.29271 9.96165L8.59753 5.9989Z' fill='%23807F7F'/%3E%3C/svg%3E%0A");
    }
  }

  &.date-icon {
    &:after {
      content: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.4998 7.42871H1.13184C0.821336 7.42871 0.569336 7.17671 0.569336 6.86621C0.569336 6.55571 0.821336 6.30371 1.13184 6.30371H14.4998C14.8103 6.30371 15.0623 6.55571 15.0623 6.86621C15.0623 7.17671 14.8103 7.42871 14.4998 7.42871Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.1509 10.3574C10.8404 10.3574 10.5854 10.1054 10.5854 9.79492C10.5854 9.48442 10.8337 9.23242 11.1442 9.23242H11.1509C11.4614 9.23242 11.7134 9.48442 11.7134 9.79492C11.7134 10.1054 11.4614 10.3574 11.1509 10.3574Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.82282 10.3574C7.51232 10.3574 7.25732 10.1054 7.25732 9.79492C7.25732 9.48442 7.50557 9.23242 7.81607 9.23242H7.82282C8.13332 9.23242 8.38532 9.48442 8.38532 9.79492C8.38532 10.1054 8.13332 10.3574 7.82282 10.3574Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.48764 10.3574C4.17714 10.3574 3.92139 10.1054 3.92139 9.79492C3.92139 9.48442 4.17039 9.23242 4.48089 9.23242H4.48764C4.79814 9.23242 5.05014 9.48442 5.05014 9.79492C5.05014 10.1054 4.79814 10.3574 4.48764 10.3574Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.1509 13.2725C10.8404 13.2725 10.5854 13.0205 10.5854 12.71C10.5854 12.3995 10.8337 12.1475 11.1442 12.1475H11.1509C11.4614 12.1475 11.7134 12.3995 11.7134 12.71C11.7134 13.0205 11.4614 13.2725 11.1509 13.2725Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.82282 13.2725C7.51232 13.2725 7.25732 13.0205 7.25732 12.71C7.25732 12.3995 7.50557 12.1475 7.81607 12.1475H7.82282C8.13332 12.1475 8.38532 12.3995 8.38532 12.71C8.38532 13.0205 8.13332 13.2725 7.82282 13.2725Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.48764 13.2725C4.17714 13.2725 3.92139 13.0205 3.92139 12.71C3.92139 12.3995 4.17039 12.1475 4.48089 12.1475H4.48764C4.79814 12.1475 5.05014 12.3995 5.05014 12.71C5.05014 13.0205 4.79814 13.2725 4.48764 13.2725Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.8451 4.34325C10.5346 4.34325 10.2826 4.09125 10.2826 3.78075V1.3125C10.2826 1.002 10.5346 0.75 10.8451 0.75C11.1556 0.75 11.4076 1.002 11.4076 1.3125V3.78075C11.4076 4.09125 11.1556 4.34325 10.8451 4.34325Z' fill='%23130F26'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.7865 4.34325C4.476 4.34325 4.224 4.09125 4.224 3.78075V1.3125C4.224 1.002 4.476 0.75 4.7865 0.75C5.097 0.75 5.349 1.002 5.349 1.3125V3.78075C5.349 4.09125 5.097 4.34325 4.7865 4.34325Z' fill='%23130F26'/%3E%3Cmask id='mask0_2806_137' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='1' width='16' height='16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.5 1.93457H15.125V16.8752H0.5V1.93457Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_2806_137)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.64075 3.05957C2.696 3.05957 1.625 4.09682 1.625 5.98007V12.7668C1.625 14.6913 2.696 15.7503 4.64075 15.7503H10.9843C12.929 15.7503 14 14.7108 14 12.8238V5.98007C14.003 5.05382 13.754 4.33382 13.2597 3.83882C12.7512 3.32882 11.9675 3.05957 10.991 3.05957H4.64075ZM10.9843 16.8753H4.64075C2.087 16.8753 0.5 15.3011 0.5 12.7668V5.98007C0.5 3.48407 2.087 1.93457 4.64075 1.93457H10.991C12.2727 1.93457 13.3325 2.31857 14.0563 3.04382C14.759 3.74957 15.1287 4.76432 15.125 5.98157V12.8238C15.125 15.3228 13.538 16.8753 10.9843 16.8753Z' fill='%23130F26'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
  }

  &.closable {
    .icon {
      top: 2rem;
      right: 2rem;
      transform: none;
      pointer-events: auto;
      cursor: pointer;
      background-color: #fff;
      border-radius: 50%;
      display: none;
    }
  }

  input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-calendar-picker-indicator,
  input[type='datetime-local']::-webkit-inner-spin-button,
  input[type='datetime-local']::-webkit-calendar-picker-indicator,
  input[type='time']::-webkit-inner-spin-button,
  input[type='time']::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  /* clears the ‘X’ from Internet Explorer */

  input::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  input::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  /* clears the ‘X’ from Chrome */

  input::-webkit-search-decoration,
  input::-webkit-clear-button,
  input::-webkit-search-cancel-button,
  input::-webkit-search-results-button,
  input::-webkit-search-results-decoration {
    display: none;
  }
`;

const CustomInput = React.forwardRef(
  (
    {
      withBorder,
      placeholder,
      icon,
      type,
      closable,
      rows,
      disabled = false,
      handleClear = () => {},
      ...props
    },
    ref
  ) => {
    const hasIcon = icon || closable || type === 'date';

    const showPicker = (e) => {
      const input = e.target.querySelector('input');
      if ('showPicker' in HTMLInputElement.prototype && input && input.showPicker) {
        input.showPicker();
      }
    };

    const containerRef = React.createRef();

    return (
      <Wrapper
        ref={containerRef}
        onClick={showPicker}
        className={cx('input-wrapper', {
          firefox: detectBrowser() === 'Firefox',
          'with-border': withBorder,
          'has-icon': hasIcon,
          'time-icon': icon === 'time',
          'date-icon': icon === 'date' || type === 'date',
          closable: closable && icon !== 'time' && icon !== 'date',
        })}>
        {type !== 'textarea' && (
          <input
            {...props}
            ref={ref}
            placeholder={placeholder}
            type={type}
            onClick={(e) => e.stopPropagation()}
            autoComplete="off"
            disabled={disabled}
          />
        )}
        {type === 'textarea' && <textarea ref={ref} {...props} rows={rows || '4'} />}
        {closable && <ClearInputIcon className="icon" onClick={handleClear} />}
      </Wrapper>
    );
  }
);
CustomInput.displayName = 'TextInput';

const ClearInputIcon = (props) => (
  <svg width={8} height={8} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.016 5.77 5.237 3.994l1.778-1.778a.874.874 0 0 0 0-1.237.872.872 0 0 0-1.237-.001L4 2.755 2.22.975a.877.877 0 0 0-1.238 0 .877.877 0 0 0 0 1.237l1.78 1.78L.986 5.769a.874.874 0 1 0 1.237 1.237L4 5.23l1.78 1.78A.876.876 0 0 0 7.016 5.77"
      fill="#130F26"
    />
  </svg>
);

function detectBrowser() {
  if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf('Chrome') != -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') != -1) {
    return 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') != -1) {
    return 'Firefox';
  } else if (navigator.userAgent.indexOf('MSIE') != -1 || !!document.documentMode == true) {
    return 'IE'; //crap
  } else {
    return 'Unknown';
  }
}

export { CustomInput };
